import React from 'react'
import web from '../Images/ar.svg'


const Card = ({color1,color2,title,para,avt,foot}) => {
    return (
        <>

            <div className={"rounded shadow-xl overflow-hidden border-1 border-blue-900 hover:shadow-2xl outline-offset-3 outline-1 outline-dashed outline-white"}>

                <div className={`px-2 py-3 flex item-center ${color1} justify-between`}>
                    <div className=''>
                        <h1 className='font-extrabold mb-4  text-white text-2xl'>{title}</h1>
                        <p className='text-white text-sm'>{para}</p>
                    </div>
                    <div className=''>
                        <img src={avt} alt="image"/>
                    </div>
                </div>

                <div className={`flex items-center justify-center ${color2} text-white ${color2} py-2 text-sm`}><a className='flex'>{foot} <img src={web} alt="icon" className='pl-1' /></a>
                </div>

            </div>
        </>
    )
}
export default Card
